import { useCallback } from 'react';
import { ColumnPairing } from 'components/forms/remote-source/config/types';
import { Group, Modal, Stack } from '@mantine/core';
import { IconColumns3 } from '@tabler/icons-react';
import { useForm } from '@mantine/form';
import Button from 'components/Button';
import ColumnPairings from 'components/forms/remote-source/config/ColumnPairings';

export interface ColumnPairingModalProps {
  initialValues: ColumnPairing[];
  onSubmit: (values: ColumnPairing[]) => void;
  opened: boolean;
  onClose: () => void;
}

/**
 * Modal for mapping column data.
 */
export default function ColumnPairingModal({ opened, onClose, initialValues, onSubmit }: ColumnPairingModalProps) {
  const form = useForm<{ columns: ColumnPairing[] }>({ initialValues: { columns: initialValues } });

  const submitForm = useCallback(
    ({ columns }: { columns: ColumnPairing[] }) => {
      onSubmit(columns);
      onClose();
    },
    [onSubmit, onClose]
  );

  return (
    <Modal
      size="auto"
      title="Mapovanie stĺpcových údajov"
      opened={opened}
      onClose={onClose}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withinPortal
    >
      <form onSubmit={form.onSubmit(submitForm)} id="column-pairing-form">
        <Stack spacing={24} pt={8}>
          <ColumnPairings form={form} formProp="columns" propType="device" />
          <Group position="right">
            <Button variant="subtle-gray" onClick={onClose}>
              Zrušiť
            </Button>
            <Button leftIcon={<IconColumns3 />} variant="primary" type="submit" form="column-pairing-form">
              Nastaviť stĺpcové údaje
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
